<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="编辑尺寸"
      width="300px"
      :innerHeight="60"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="form" size="small" :rules="rules" ref="ruleForm">
        <el-form-item label="尺寸" prop="productSize">
          <el-input v-model="form.productSize" />
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import { isIntZero } from '@/utils/validate.js'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'rowData'],
  data() {
    const validator_IntZero = (rule, value, callback) => {
      if(isIntZero(value)) {
        callback()
      }else{
        callback(new Error('必须为正整数'))
      }
    }
    return {
      dialogVisible: false,
      // 业务代码
      form: {},
      rules: {
        productSize: [
          { required: true, message: '调整数量不能为空', trigger: 'blur'},
          { validator: validator_IntZero, trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    console.log('123');
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          let data = {
            data: {
              productCode: this.rowData.productCode,
              productSize: this.form.productSize
            }
          }
          this.$q.product.productEdit(data)
          .then(res=>{
            if(res.code == 200) {
              this.$message.success('保存成功')
            }else{
              this.$message.error(res.message)
            }
          })
          .finally(_=>{
            this.$parent.onSearch();
            this.updateVal();
          })
        }
      })
    }
  }
}
</script>

<style>

</style>